import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { preloadMap } from './components/MaptoolkitMap';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
// 첫 화면이 지도이므로 지도 라이브러리를 렌더링과 동시에 받기 시작합니다.
if (window.location.pathname === '/') preloadMap();
// 첫 화면이 뜬 뒤 한가할 때 자주 가는 페이지 코드를 미리 받아 둡니다.
const idle = window.requestIdleCallback || (fn => setTimeout(fn, 2500));
idle(() => { import('./pages/NewsPage'); import('./pages/ProductPage'); import('./pages/CalculatePage'); });
